module.exports = __webpack_public_path__ + "img/35.94563801.png";